export const guides = [
  {
    id: "g1",
    title: "新手吃瓜指南：三分钟看懂一个大瓜的时间线",
    subtitle: "别再从热搜的第十个词条开始乱猜了",
    readTime: "6 分钟",
    updated: "2026-09-08",
    catName: "方法论",
    excerpt: "大瓜最劝退的，是满屏缩写与断断续续的前情。这篇吃瓜指南教你把任何事件拆成「起因—引爆—反转—后续」四段，三分钟就能跟上大部队。",
    tags: ["新手", "时间线", "补课", "方法论"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20chronology%20timeline%20with%20milestone%20dots%20and%20an%20hourglass%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20newspaper%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=guide-g1-cover&orientation=landscape",
    sections: [
      { heading: "为什么你总觉得瓜是‘突然’出现的", body: ["热搜上一个瓜之所以显得‘突然’，几乎都是因为你错过了它的前情。真正会吃瓜的老手，从不从热搜第一条开始看，而是先找到事件最早的那条源头。", "记住一个原则：越靠后的热搜词条，越可能是对前面事件的回应、澄清或反转。倒着读，往往能拼出完整的剧情线。"] },
      { heading: "把任何事件拆成四段", body: ["第一步，找起因。翻到最早的相关词条，看清楚是什么引子让这件事开始被讨论，是发言、是照片、还是一段视频。", "第二步，找引爆点。一个瓜能爆，一定有一张截图、一句话或一个动作让关注量陡增，这个点决定了整个事件的讨论基调。", "第三步，找反转与补充。当事人回应、平台公告、第三方爆料都会不断推翻前面版本，把每一次‘更新’记下来，剧情就不会乱。", "第四步，看后续。热度过去不等于结束，真正的结局往往在几周后的复盘里。想吃到完整的瓜，别急着下结论。"] },
      { heading: "工具：把信息做成自己的小卡片", body: ["别把瓜都记在脑子里，随手建一个备忘录，按时间记下每一件事的日期、说法与信源，三分钟就能读完一个大瓜，也是这个习惯帮你完成的。", "当你把时间线拉直、把版本对齐，那些看起来冲突的说法，其实大多数都能在同一张时间表上找到各自的位置。看懂结构，你就领先了半个瓜田。"] },
    ],
    relatedGuides: ["g2", "g4"],
  },
  {
    id: "g2",
    title: "如何辨别真假瓜：吃瓜群众的信源分级与打假清单",
    subtitle: "截图会骗人，账号会带节奏，这份清单帮你少上钩",
    readTime: "8 分钟",
    updated: "2026-09-06",
    catName: "方法论",
    excerpt: "吃瓜吃得开心，也要吃得清醒。这篇指南教你给信息分个级：第一手信源、转述、脑补和带节奏的区别到底在哪，附一份可直接照做的打假清单。",
    tags: ["打假", "信源", "鉴别", "理性吃瓜"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20magnifying%20glass%20over%20documents%20with%20fake%20stamp%20and%20checkmarks%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20newspaper%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=guide-g2-cover&orientation=landscape",
    sections: [
      { heading: "给信源分四级，一眼看清可信度", body: ["第一级：当事人本人或涉事方原话。直播、专访、官方公告，虽然也未必客观，但这是所有讨论绕不开的锚点。", "第二级：可靠的现场记录。无剪辑的原始视频、完整的聊天记录长图，价值高于任何一段只截取了片段的‘亮点’。", "第三级：转述与解读。博主的长文、媒体的总结，方便理解，但转述必有损耗，务必回到原话核对。", "第四级：脑补与情绪。一切只有结论没有证据、只有立场没有出处的说法，都先当成氛围感，别当成事实。"] },
      { heading: "打假清单：开吃前先过五关", body: ["一关：截图能对上号吗？时间、账号、头像是否与真实对得上，很多假瓜栽在‘日期穿越’上。", "二关：谁在说？爆料者是当事人、利益相关方还是纯路人，决定了他说话的动机与可信度。", "三关：证据能闭环吗？一个瓜是否成立，看它能不能被至少两个互不相关的信源交叉印证。", "四关：急吗？越是催你‘马上转’‘不然删了’的瓜，越要慢下来，热度不是真相的代言人。", "五关：下结论了吗？当事人还没回应就急着判刑，是最容易被回旋镖打到的吃法。"] },
      { heading: "理性吃瓜，是最高级的吃法", body: ["辨别真假瓜的意义，不是让你变得谁都不信，而是让你把有限的热情，花在站得住脚的瓜上。", "当你学会给每条信息贴上信源标签，你就会发现：真正的好瓜，根本不需要靠煽动情绪来撑场面，它的证据本身就足够硬。"] },
    ],
    relatedGuides: ["g3", "g1"],
  },
  {
    id: "g3",
    title: "热搜词条怎么读：从 # 到「爆」，背后的热度逻辑一次讲清",
    subtitle: "看懂词条后缀，就读懂了大瓜的气压",
    readTime: "5 分钟",
    updated: "2026-09-05",
    catName: "方法论",
    excerpt: "同样是上热搜，为什么有的是 #新#、有的是「沸」、有的是「爆」？这篇指南帮你解读热度标识的差异，以及词条热度高不高的真实含义。",
    tags: ["热搜", "词条", "热度", "平台机制"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20thermometer%20with%20hashtag%20symbols%20rising%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20magazine%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=guide-g3-cover&orientation=landscape",
    sections: [
      { heading: "热度标识不只是装饰", body: ["词条后面的「新」「热」「沸」「爆」，本质是平台根据讨论量、增长速度与活跃账号数算出的一个综合气压计，数字相近但场景不同，含义也不一样。", "「沸」往往代表讨论面广、参与人多，而「爆」代表极短时间内的集中爆发，后者通常对应有明确引爆点的事件。"] },
      { heading: "读词条要连起来读", body: ["单一词条信息量有限，真正重要的是词条之间的关系：谁在前情里、谁在回应谁、谁在为谁澄清。把一串相关词条当成一份动态文档读，比盯着单个词条更接近全貌。", "还有一个反直觉的经验：突然空降且不带前后文的新词条，往往背后有推广动作，遇到时不妨先回到它对应的真实源头核一遍。"] },
      { heading: "热度高 ≠ 信息真", body: ["热度只回答‘有多少人在讨论’，不回答‘讨论的是不是真相’。被顶上来的词条可能很真，也可能只是一张以讹传讹的截图。", "所以看懂热搜之后，记得回到信源分级里做最后一步：让热度和证据各自归位，你的瓜才吃得明白。"] },
    ],
    relatedGuides: ["g2", "g4"],
  },
  {
    id: "g4",
    title: "复盘体怎么写：把一场风波讲成别人愿意读完的故事",
    subtitle: "会吃瓜更要会复盘，这套结构让你越写越清楚",
    readTime: "7 分钟",
    updated: "2026-09-03",
    catName: "创作",
    excerpt: "想把一个复杂风波讲清楚，靠的不是文笔而是结构。这篇吃瓜指南分享一套可以直接套用的复盘框架：从锚点、时间线到多方立场，一步步搭建。",
    tags: ["复盘", "写作", "结构", "内容创作"],
    cover: "https://readdy.ai/api/search-image?query=flat%20vector%20pop%20art%20illustration%20of%20a%20typewriter%20with%20flying%20paper%20sheets%20and%20story%20outline%20blocks%2C%20melon%20red%20rind%20green%20and%20cream%20paper%20palette%2C%20retro%20newspaper%20collage%2C%20no%20text%2C%20screenprint%20texture&width=800&height=600&seq=guide-g4-cover&orientation=landscape",
    sections: [
      { heading: "先立锚点：一句话讲清你写的是哪个瓜", body: ["复盘的第一句，就要让没跟上热搜的人秒懂：是哪件事、牵涉谁、为什么值得看。用一个简洁的引子把读者拉进场景，比堆砌时间节点更重要。", "锚点里不要急着表态，先中立地把‘发生了什么’讲清楚，后面的分析与立场才有站稳的支点。"] },
      { heading: "时间线是骨架，取舍比罗列重要", body: ["真正的复盘不是流水账，而是在所有已知节点里挑出真正改变剧情走向的少数几个：引爆点、反转点、回应点。其余细节可以作为补充，但别让它们淹没主线。", "在每个关键节点下，交代清楚‘说了什么、谁说的、为何关键’，读者就会顺着你的结构自然走完全程。"] },
      { heading: "给多方立场留位置，复盘才有厚度", body: ["好的复盘会克制地呈现各方说法，而不是只讲一种声音。你把不同立场摆清楚，读者才有空间形成自己的判断，这也是复盘与单纯发泄情绪的本质区别。", "最后用一句收束的话，既点出事件现状，也留出‘未完待续’的余地。结构完整、立场克制的复盘，往往比情绪激动的长文更能留人。"] },
    ],
    relatedGuides: ["g1", "g2"],
  },
];